import { EarbudsOutlineIcon } from './EarbudsOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 15AB1BAE-A458-4107-9C96-07BF755F3EBA
 * name earbuds-outline
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earbuds-outline.svg
 * tags
 * - Audio 
 * - Music 
 */
export const HeadphonesOutlineIcon = EarbudsOutlineIcon;
export default HeadphonesOutlineIcon